import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/home/home";
import Teach from "../pages/teach/teach";
import Contact from "../pages/contact/contact";
function Router() {

        return (
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/teach" element={<Teach />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        );
};

export default Router;
